import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, CusEcommerceGetters } from './types';

const _getters = namespaceHelper.removeNamespace(namespace, CusEcommerceGetters);

export default {
  [_getters.GET_PARTS]: state => {
    return state.partList;
  }
};
